// LAYOUT

export const HEADER = {
  HEIGHT: 60,
};

export const NAVBAR = {
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 80,
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
};

// SETTINGS
// Please remove `localStorage` when you set settings.

export type ThemeModeValue = 'light' | 'dark';
type ThemeDirectionValue = 'rtl' | 'ltr';
type ThemeContrastValue = 'default' | 'bold';
type ThemeColorPresetsValue = 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red';
type ThemeStretchValue = boolean;

type SettingsValueProps = {
  themeMode: ThemeModeValue;
  themeStretch: ThemeStretchValue;
  themeContrast: ThemeContrastValue;
  themeDirection: ThemeDirectionValue;
  themeColorPresets: ThemeColorPresetsValue;
};

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeColorPresets: 'default',
  themeStretch: false,
};

// TABLE HIGHLIGHTING

/**
 * How many ms ago the table row was created/updated to be considered "new" and highlighted
 *  */
export const HIGHLIGHT_TRIGGER_DURATION = 20000;

/**
 * How long the table row should be highlighted for
 *  */
export const HIGHLIGHT_AUTO_HIDE_DURATION = 600;

/**
 * Highlight color opacity (0-1)
 */
export const HIGHLIGHT_OPACITY = 0.12;

export const ICON_SIZE_MAP = {
  xs: 12,
  xsPlus: 14,
  sm: 16,
  smMinus: 18,
  smPlus: 20,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48,
  xxxl: 64,
};

/** Fixed row height every row plugged into `PLinkedEntityList` must honor. */
export const LIST_ROW_HEIGHT = 64;
